import { render, staticRenderFns } from "./TreatmentEvaluate.vue?vue&type=template&id=805db334"
import script from "./TreatmentEvaluate.vue?vue&type=script&lang=js"
export * from "./TreatmentEvaluate.vue?vue&type=script&lang=js"
import style0 from "./TreatmentEvaluate.vue?vue&type=style&index=0&id=805db334&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('805db334')) {
      api.createRecord('805db334', component.options)
    } else {
      api.reload('805db334', component.options)
    }
    module.hot.accept("./TreatmentEvaluate.vue?vue&type=template&id=805db334", function () {
      api.rerender('805db334', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/evaluate/TreatmentEvaluate.vue"
export default component.exports